import { request } from '../../utils'

// These endpoints are still on API v1, which only returns JSON when explicitly
// asked via `format=json&raw=1`. The new fetch layer no longer injects those, so
// we pass them here until these calls are migrated to `/api/2/...`.
const V1_JSON = { format: 'json', raw: '1' }

export const fetchPoll = (objectId, token, data = {}) => {
  return request({
    url: '/api/poll/list',
    method: 'GET',
    data: {
      object_id: objectId,
      object_token: token,
      ...V1_JSON,
      ...data,
    },
  })
}

export const createPoll = (objectId, question, data = {}) => {
  return request({
    url: '/api/poll/add',
    method: 'POST',
    data: {
      ...data,
      question,
      object_id: objectId,
      ...V1_JSON,
    },
  })
}

export const deletePoll = (pollId) => {
  return request({
    url: '/api/poll/remove',
    method: 'POST',
    data: {
      poll_id: pollId,
      ...V1_JSON,
    },
  })
}

export const updatePoll = (pollId, data) => {
  return request({
    url: '/api/poll/update',
    method: 'POST',
    data: {
      ...data,
      poll_id: pollId,
      ...V1_JSON,
    },
  })
}

export const setOptions = (pollId, options) => {
  return request({
    url: '/api/poll/set-options',
    method: 'POST',
    data: {
      options,
      poll_id: pollId,
      ...V1_JSON,
    },
  })
}

export const vote = (objectId, token, pollId, uuid, optionId) => {
  return request({
    url: '/api/poll/answer',
    method: 'POST',
    data: {
      object_id: objectId,
      uuid,
      object_token: token,
      poll_id: pollId,
      poll_option_id: optionId,
      ...V1_JSON,
    },
  })
}
